import { Dispatch, UnknownAction } from "@reduxjs/toolkit";
import BaseApp, { IBaseApp, IBaseAppDynamicBasePage, IGridDataAdditional } from "../BaseApp";
import { useReturnUsersLoadingStatus, useReturnUsersPagination, useReturnUsersSearch } from "../user/userSlice";
import { addNewUserGroup, deleteUserGroup, setSelectedUserGroups, setUserGroupsSearchParams, updateAllUserGroups, updateUserGroup, updateUserGroupsLoadingStatus, updateUserGroupsPagination, updateUserGroupsSearch, useReturnAllUserGroups, useReturnSelectedUserGroups, useReturnUserGroupsSearchParams } from "./userGroupsSlice";
import { IUserGroupModel } from ".";
import { GridDataColumns, IGridDataConfig } from "../../components/GridData";

/**
 * User Groups App
 */
export default class UserGroupsApp extends BaseApp implements IBaseApp {

    appName = "user_groups"
    appBaseEndPoint = "/users/groups"

    customListEndPoint: string = this.appBaseEndPoint

    elemPrefix: string = "user_groups_"

    /**
     * Dynamic Base Page
     */
    dynamicBasePage: IBaseAppDynamicBasePage = {
        items: useReturnAllUserGroups,
        pagination: useReturnUsersPagination,
        loading: useReturnUsersLoadingStatus,
        search: useReturnUsersSearch,
        updateLoadingStatus: (status: boolean, dispatch: Dispatch <UnknownAction>) => dispatch(updateUserGroupsLoadingStatus({ loading: status })),
        deleteItem: (id: number, dispatch: Dispatch<UnknownAction>) => dispatch(deleteUserGroup({ id: id })),
        addNewItem: (item, dispatch) => dispatch(addNewUserGroup((item as IUserGroupModel))),
        updateItem: (item, dispatch) => dispatch(updateUserGroup((item as IUserGroupModel))),
        updateAllItems: (items, dispatch) => dispatch(updateAllUserGroups((items as IUserGroupModel[]))),
        updateSearch: (search: string, dispatch: Dispatch<UnknownAction>) => dispatch(updateUserGroupsSearch({ search: search })),
        updateItemsPagination: (pagination, dispatch) => dispatch(updateUserGroupsPagination(pagination)),
        itemsActionOptions: [
            {
                icon: "edit",
                label: "Edit",
                link: "/panel/user_groups/edit/[id]",
                onClick: (rawItem) => {
                    // navigate("/panel/items/edit/" + rawItem.id)
                },
            },
            {
                icon: "show",
                label: "View",
                link: "/panel/user_groups/view/[id]",
                onClick: (rawItem) => {
                    // navigate("/panel/items/view/" + rawItem.id)
                },
            },
        ],
    }


    /**
     * Grid data
     */
    gridDataColumns: GridDataColumns = [
        // {
        //     field: "title",
        //     headerName: "Title",
        //     type: "title",
        //     minWidth: 400,
        // },
        {
            field: "title",
            headerName: "Department",
            type: "title",
            width: 400,
            minWidth: 400,
            cellRendererParams: {
                appClass: () => new UserGroupsApp(),
                enableQuickPreview: true,
            }
        },
    ]
    useGridData: boolean = true
    gridConfig: IGridDataConfig = {
        viewItemLink: "/panel/user_groups/edit/[id]",
        editItemLink: "/panel/user_groups/edit/[id]",
    }
    gridDataEssentials: IGridDataAdditional  = {
        selectedItems: useReturnSelectedUserGroups,
        searchParams: useReturnUserGroupsSearchParams,
        actionButtons: [
            // {
            //     icon: "edit",
            //     isIconButton: true,
            //     onClick(data, dispatch, navigate) {
            //         navigate("/panel/user_groups/")
            //     },
            // }
        ],
        headerOptions: [],
        setSelectedItems: (items, dispatch) => dispatch(setSelectedUserGroups(items)),
        updateItemSearchParams: (params, dispatch) => dispatch(setUserGroupsSearchParams(params))
    }

}